// components
//import ContextPanelNavigation from './components/ContextPanelNavigation';

// constants
import { ContextPanelMenuItems } from './ContextPanel.consts';

// hooks
import { useMemo, useState } from 'react';
import { useContextPanelStore } from './ContextPanel.store';

// styles
import { Content, StyledContextPanel } from './ContextPanel.styles';

// types
import {
  ContextPanelMenuItem,
  ContextPanelNavigationItemType,
  ContextPanelProps
} from './ContextPanel.types';
import { ContextPanelHeader } from './components/ContextPanelHeader/ContextPanelHeader';

const ContextPanel = ({
  onPanelSizeChange,
  isAppointmentOpen = false
}: ContextPanelProps) => {
  const panelSize = useContextPanelStore((state) => state.panelSize);
  const width = useMemo(() => panelSize.valueOf(), [panelSize]);

  const [activePanel, _setActivePanel] = useState<ContextPanelMenuItem | null>(
    ContextPanelMenuItems.find(
      (item) => item.id === ContextPanelNavigationItemType.LOG
    )!
  );

  return (
    !isAppointmentOpen && (
      <StyledContextPanel width={width}>
        <ContextPanelHeader
          label={activePanel?.label || ''}
          onPanelSizeChange={onPanelSizeChange}
        />

        <Content role="tabpanel">{activePanel?.component}</Content>

        {/* Uncomment to enable navigation between panels (or use MUI Tabs) */}
        {/* <ContextPanelNavigation
        panelSize={panelSize}
        onMenuItemChange={setActivePanel}
      /> */}
      </StyledContextPanel>
    )
  );
};

export default ContextPanel;
